module.exports = __webpack_public_path__ + "img/tab-vehicle-row-side-honda.d3a31ccd.png";